import script from "./InsuranceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InsuranceModal.vue?vue&type=script&setup=true&lang=js"

import "./InsuranceModal.vue?vue&type=style&index=0&id=1490dff2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1490dff2"]])

export default __exports__